import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axiosConfig';

export const getNavbarData = createAsyncThunk(
    'app/getNavbarData',
    async (_, { rejectWithValue }) => {
        try {
            const res = await axios.get('/somnium/navbar-data');
            return res.data.payload;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message);
        }
    }
);

export const getHomePageData = createAsyncThunk(
    'app/getHomePageData',
    async (_, { rejectWithValue }) => {
        try {
            const res = await axios.get('/somnium/get-home-page');
            return res.data?.payload;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message);
        }
    }
);

export const getContactUsData = createAsyncThunk(
    'app/getContactUsData',
    async (_, { rejectWithValue }) => {
        try {
            const res = await axios.get('/somnium/contact-us');
            return res.data.payload;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message);
        }
    }
);

export const getAboutData = createAsyncThunk(
    'app/getAboutData',
    async (_, { rejectWithValue }) => {
        try {
            const res = await axios.get('/somnium/get-about-page');
            return res.data?.payload;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message);
        }
    }
);
export const getEnterprisesData = createAsyncThunk(
    'app/getEnterprisesData',
    async (_, { rejectWithValue }) => {
        try {
            const res = await axios.get('/somnium/get-enterprises-page');
            return res.data?.payload;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message);
        }
    }
);

export const getMetaData = createAsyncThunk(
    'app/getMetaData',
    async ({ page }, { rejectWithValue }) => {
        try {
            const res = await axios.get('/somnium/page-meta-data', {
                params: {
                    path: 'somnium',
                    page
                }
            });
            return res.data.payload;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message);
        }
    }
);
